<div class="glance" *ngIf="isOpen" role="dialog" aria-label="Buddy glance">

  <div class="glance__head">
    <app-bb-mascot [state]="bbState" [stage]="progress.stage" [size]="30" [decorative]="true"></app-bb-mascot>
    <div class="glance__identity">
      <span class="glance__headline">{{ status.headline }}</span>
      <span class="glance__detail">{{ status.detail }}</span>
    </div>
    <span class="glance__streak" [attr.aria-label]="progress.streakDays + ' day streak'">
      {{ progress.streakDays }}d
    </span>
  </div>

  <div class="glance__quest">
    <div class="glance__quest-head">
      <span class="glance__quest-label">Daily quest</span>
      <span class="glance__quest-count">{{ questLine }}</span>
    </div>
    <div class="glance__track"><div class="glance__fill" [style.width.%]="questPct"></div></div>
  </div>

  <div class="glance__actions">
    <button
      type="button"
      class="glance__action"
      *ngFor="let action of quickActions; trackBy: trackAction"
      (click)="runQuickAction(action)"
    >
      <span class="glance__action-glyph" aria-hidden="true" [style.color]="accentFor(action)">{{ action.glyph }}</span>
      <span class="glance__action-label">{{ action.label }}</span>
      <span class="glance__action-xp">+{{ action.xp }}</span>
    </button>
  </div>

  <div class="glance__foot">
    <button type="button" class="glance__open" (click)="openBuddy()">
      Open Buddy <span class="glance__hotkey">Alt+Space</span>
    </button>
    <button type="button" class="glance__mic" aria-label="Open Buddy and start voice input" (click)="openBuddy()">⏺</button>
  </div>
</div>
